import { Component } from '@angular/core';
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { Router } from '@angular/router'
import { LoaderService } from '../../services/loader-service/loader.service';
import { EVENT_NAMES } from '../../utils/events'

@Component({
  selector: 'app-page-view-base',
  templateUrl: './page-view-base.component.html',
})
export class PageViewBaseComponent {
  productFlow: string = ''
  process: string = ''
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(
    protected router: Router,
    protected loaderService: LoaderService,
  ) {}
  
  public handleRedirect = () => {
    this.router.navigate([this.productFlow, this.process], { replaceUrl: true })
  }

  ngOnInit() {
    const loginConfig = this.storage.get(EVENT_NAMES.loginConfig)
    const flow = loginConfig && loginConfig.flow ? loginConfig.flow : 'transaccional'
    const process = loginConfig && loginConfig.process ? loginConfig.process : 'autogestion'
    this.productFlow = flow
    this.process = process
    setTimeout(() => {
      this.loaderService.updateLoader(false)
    }, 500)
  }
}
